// Filename - pages/login.js

import React from "react";
import Rodape from './rodape.js';
import { Header } from './header.js';

const Login = () => {
    const [isMobile, setIsMobile] = React.useState(false);
    // Function to check if the device is a mobile
    const checkIfMobile = () => {
        const isMobileDevice = window.matchMedia('(max-width: 768px)').matches;
        setIsMobile(isMobileDevice);
    };
    React.useEffect(() => {
        checkIfMobile();
        // Add event listener to check if the device type changes
        window.addEventListener('resize', checkIfMobile);
        // Remove event listener on component unmount
        return () => window.removeEventListener('resize', checkIfMobile);
    }, []);
	return (
    <>
        <Header isMobile={isMobile}/>
        <section id="form" className="section">
            <h1>Aviso importante (LEIA TUDO COM ATENÇÃO):</h1>
            <div className="form-container">
                <p>Os cursos foram migrados para uma nova plataforma no sistema Moodle.</p>
                <p>Se você é aluno do curso Domínio Elétrico, faça login na nova plataforma:</p>
                <p><b>Login:</b> (o mesmo email que você já usava)</p>
                <p><b>Senha:</b> ksdafL8& (senha padrão)</p>
                <p>A senha <b>não</b> é a mesma da conta que você tinha na plataforma anterior. Caso você ainda não tenha acessado o curso na plataforma nova, tente a senha padrão acima.</p>
                <p>Você também poderá usar o link <i>"Perdeu sua senha?"</i> presente na página de login da nova plataforma para configurar uma nova senha. </p>
                <p>Os cursos não estão mais disponíveis neste endereço (dominioeletrico.com.br), mas apenas na nova plataforma.</p>
                <p><b>Se você leu com atenção todas as informações acima, clique no botão abaixo: </b></p>
                <button className="new-platform" onClick={() => window.location.href='https://curso.dominioeletrico.com.br/login/'}>
                    Acessar a nova plataforma
                </button>
                <p><b>Dica:</b> Adicione a página de login da nova plataforma <i>(https://curso.dominioeletrico.com.br/login)</i> nos favoritos do seu navegador.</p>
            </div>
    </section>
    <Rodape />
    </>
	);
};

export default Login;